'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeThreadMessageReceived = undefined;

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _postConversationClosedEvent = require('../../threads/actions/postConversationClosedEvent');

var _defaultMessageReceived = require('../../actions/defaultMessageReceived');

var closeThreadMessageReceived = exports.closeThreadMessageReceived = function closeThreadMessageReceived(_ref) {
  var message = _ref.message,
      channel = _ref.channel,
      thread = _ref.thread;
  return function (dispatch) {
    var threadId = (0, _threadGetters.getThreadId)(thread);

    dispatch((0, _postConversationClosedEvent.postConversationClosedEvent)({ thread: thread }));
    dispatch((0, _defaultMessageReceived.defaultMessageReceived)(message, channel, threadId));
  };
};